var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactQuestionFactory, SurveyQuestionElementBase, SvgIcon } from "survey-react-ui";
var SurveyQuestionTextWithReset = /** @class */ (function (_super) {
    __extends(SurveyQuestionTextWithReset, _super);
    function SurveyQuestionTextWithReset() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyQuestionTextWithReset.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionTextWithReset.prototype.renderElement = function () {
        var textElement = this.renderInput();
        var resetButton = this.renderResetButton();
        return (React.createElement("div", { className: this.question.getRootClass() },
            textElement,
            resetButton));
    };
    SurveyQuestionTextWithReset.prototype.renderInput = function () {
        return ReactQuestionFactory.Instance.createQuestion(this.question.wrappedQuestionTemplate, {
            question: this.question,
            isDisplayMode: this.question.isInputReadOnly,
            creator: this,
        });
    };
    SurveyQuestionTextWithReset.prototype.renderResetButton = function () {
        var _this = this;
        return (React.createElement("button", { className: this.question.cssClasses.resetButton, disabled: this.question.resetValueAdorner.isDisabled, title: this.question.resetValueAdorner.caption, onClick: function () { return _this.question.resetValueAdorner.resetValue(); } },
            React.createElement(SvgIcon, { iconName: this.question.cssClasses.resetButtonIcon, size: "auto" })));
    };
    return SurveyQuestionTextWithReset;
}(SurveyQuestionElementBase));
export { SurveyQuestionTextWithReset };
ReactQuestionFactory.Instance.registerQuestion("textwithreset", function (props) {
    return React.createElement(SurveyQuestionTextWithReset, props);
});
ReactQuestionFactory.Instance.registerQuestion("commentwithreset", function (props) {
    return React.createElement(SurveyQuestionTextWithReset, props);
});
